var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"color":"primary","height":"56px","app":""}},[_c('LogoWidget',{attrs:{"height":46}}),_c('v-spacer'),_c('FloatSearchWidget'),_c('v-app-bar-nav-icon',{attrs:{"color":"white"},on:{"click":_vm.showNavigationDrawer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }